import React from 'react';

const MultiSelectionInput = ({
  label,
  placeholder,
  value,
  onSearch,
  onSelect,
  onClear,
  results,
  isActive,
  onFocus,
  selectedItems,
  onRemoveItem
}) => {
  // Filter out selected items from results
  const filteredResults = results?.filter(result =>
    !selectedItems?.some(selected => selected.id === result.id)
  );

  return (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <div className="relative">
        {/* Selected Items Display */}
        {selectedItems && selectedItems.length > 0 && (
          <div className="mb-2">
            {selectedItems.map((item) => (
              <div
                key={item._id}
                className="d-inline-block me-2 mb-2"
              >
                <div className="badge bg-primary d-flex align-items-center">
                  <span className="me-2">{item.slug}</span>
                  <button
                    className="btn btn-sm btn-link text-white p-0"
                    onClick={() => onRemoveItem(item.id)}
                    style={{ textDecoration: 'none' }}
                  >
                    X
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Search Input */}
        <div className="flex items-center border rounded">
          <input
            type="text"
            className="form-control border-0"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onSearch(e.target.value)}
            onFocus={onFocus}
          />
          {value && (
            <button
              className="btn btn-link text-secondary p-2"
              onClick={() => {
                onClear();
                onSearch('');
              }}
              type="button"
              aria-label="Clear selection"
            >
              {/* <X size={18} /> */}
            </button>
          )}
        </div>

        {/* Dropdown Results - Show only unselected items */}
        {isActive && filteredResults?.length > 0 && (
          <div className="absolute w-full mt-1 bg-white border rounded shadow-lg z-10 max-h-60 overflow-y-auto">
            {filteredResults.map((item) => (
              <div
                key={item.id}
                className="p-3 hover:bg-gray-100"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onSelect(item);
                  onSearch('');
                }}
              >
                <h6 className="mb-0 text-primary">{item.slug}</h6>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelectionInput;